import React, { Component } from "react";
import { connect } from "react-redux";
import {
  removeItem,
  addQuantity,
  subtractQuantity
} from "../../actions/cart_Action";
import Recipe from "../Recipe";
import CartColumn from "./CartColumns";
import Sidebar from "../Sidebar";
import { Row, Col } from "react-bootstrap";

class Cart extends Component {
  //to remove the item completely
  handleRemove = key => {
    this.props.removeItem(key);
  };
  //to add the quantity
  handleAddQuantity = key => {
    this.props.addQuantity(key);
  };
  //to substruct from the quantity
  handleSubtractQuantity = key => {
    this.props.subtractQuantity(key);
  };
  render() {
    // const product =this.props.inititems

    let addedItems = this.props.inititems.length ? (
      this.props.inititems.map(item => {
        return (
          <li className="collection-item avatar" key={item.id}>
            <div className="row my-2 text-capitalize text-center">
              <div className="col-10 mx-auto col-lg-2">
                <img
                  src={item.img}
                  style={{ width: "5rem", height: "5rem" }}
                  className="img-fluid"
                  alt="food"
                />
              </div>

              <div className="col-10 mx-auto col-lg-2">
                <span className="title">{item.p_name}</span>
                {/* <p>{item.desc}</p> */}
              </div>

              <div className="col-10 mx-auto col-lg-2">
                <span className="d-lg-none">price: </span>
                {item.price}
              </div>

              <div className="col-10 mx-auto col-lg-2 my-2 my-lg-0">
                <div className="d-flex justify-content-center">
                  <span
                    className="btn btn-black mx-1"
                    onClick={() => {
                      this.handleSubtractQuantity(item.key);
                    }}
                  >
                    -
                  </span>
                  <span className="btn btn-black mx-1">{item.quantity}</span>

                  <span
                    className="btn btn-black mx-1"
                    onClick={() => {
                      this.handleAddQuantity(item.key);
                    }}
                  >
                    +
                  </span>
                </div>
              </div>

              <div className="col-10 mx-auto col-lg-2">
                <div className="cart-icon">
                  <i
                    className="fas fa-trash"
                    onClick={() => {
                      this.handleRemove(item.key);
                    }}
                  />
                </div>
              </div>
            </div>
          </li>
        );
      })
    ) : (
      <p>Nothing.</p>
    );
    return (
      <>
        <div className="container-fluid">
          <Row>
            <Col sm={3}>
              <Sidebar />
            </Col>

            <Col sm={9}>
              <br />
              <br />
              <br />
              <div className="cart">
                <h5>You have ordered:</h5>
                <CartColumn />
                <ul className="collection">{addedItems}</ul>
              </div>
              <Recipe eosio3={this.props.eosio2}   tokenName2={this.props.tokenName} contractName2={this.props.contractName}/>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    inititems: state.addedItems
  };
};
const mapDispatchToProps = dispatch => {
  return {
    removeItem: key => {
      dispatch(removeItem(key));
    },
    addQuantity: key => {
      dispatch(addQuantity(key));
    },
    subtractQuantity: key => {
      dispatch(subtractQuantity(key));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cart);
